export default __webpack_public_path__ + "agent_bg5_m4297a2.png";